/*
  VBRNTT slider (sections/vbrntt-slides.liquid). The track is a native
  scroll-snap row, so swipe and trackpad scrolling work with or without this
  script. This adds the previous/next buttons, left/right arrow keys on the
  focused slider, and the "3 of 14" position line. Movement is instant when
  the visitor prefers reduced motion. Without JavaScript the buttons stay
  hidden and the row still scrolls.
*/
if (!customElements.get('vbrntt-slider')) {
  customElements.define(
    'vbrntt-slider',
    class VbrnttSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.countEl = this.querySelector('[data-count]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        if (!this.track || this.slides.length < 2) return;
        this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.querySelector('[data-controls]').hidden = false;
        this.onScroll = () => {
          window.cancelAnimationFrame(this.frame);
          this.frame = window.requestAnimationFrame(() => this.update());
        };
        this.onKey = (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1); }
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.onKey);
        this.prev.addEventListener('click', () => this.go(this.index - 1));
        this.next.addEventListener('click', () => this.go(this.index + 1));
        this.index = 0;
        this.update();
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
        if (this.viewport) this.viewport.removeEventListener('keydown', this.onKey);
      }

      /* The slide whose left edge is nearest the track's scroll position, or the
         last one once the track is scrolled to its end (on phones two thumbnails
         show at once, so the last can never reach the left edge). */
      current() {
        const left = this.track.scrollLeft;
        if (left >= this.track.scrollWidth - this.track.clientWidth - 2) return this.slides.length - 1;
        let best = 0;
        let bestDistance = Infinity;
        this.slides.forEach((slide, i) => {
          const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
          if (distance < bestDistance) { bestDistance = distance; best = i; }
        });
        return best;
      }

      go(index) {
        const i = Math.max(0, Math.min(this.slides.length - 1, index));
        this.track.scrollTo({
          left: this.slides[i].offsetLeft - this.track.offsetLeft,
          behavior: this.reduce.matches ? 'auto' : 'smooth',
        });
        this.index = i;
        this.render();
      }

      update() {
        this.index = this.current();
        this.render();
      }

      render() {
        const total = this.slides.length;
        if (this.countEl) {
          this.countEl.textContent = (this.dataset.counterText || '[n] of [total]')
            .replace('[n]', String(this.index + 1))
            .replace('[total]', String(total));
        }
        this.prev.disabled = this.index === 0;
        this.next.disabled = this.index === total - 1;
      }
    }
  );
}
